import React from "react";
import Sozlesmeler from "./Sozlesmeler";

const AcikRiza = () => {
  const content = [
    {
      heading: "KİŞİSEL VERİLERİN İŞLENMESİNE DAİR AÇIK RIZA METNİ",
      text: [
        "6698 sayılı Kişisel Verilerin Korunması Kanunu gereğince, kişisel verilerimin şirketiniz tarafından işlenmesine ilişkin Aydınlatma Metnini; kayıt altına alınan tarihte temin ettiğimi, okuduğumu, incelediğimi, değerlendirdiğimi ve Aydınlatma Metninde bildirilen tüm hususları bilerek, anlayarak kabul ettiğimi; paylaşmış olduğum kişisel verilerin doğru ve güncel olduğunu; işbu bilgilerde değişiklik olması halinde değişiklikleri bildireceğimi, özgür iradem sonucu bu metinde belirtilen amaç ve nedenlerle, KVKK’da tanımı yapılmış olan ve gerek içeriği gerekse toplanma yeri ve yöntemi bu metinde belirtilen kişisel verilerimin yine Aydınlatma Metninde belirtilen kişilerle/kurumlarla/kuruluşlarla paylaşılmasına, KVKK’nda tanımlanan kapsamda işlenmesine muvafakat ettiğimi ve sms veya mail vb. yollarla tarafıma bildirim yapılmasına izin verdiğimi kabul, beyan ve taahhüt ederim.",
      ],
    },
  ];

  return <Sozlesmeler title="Açık Rıza Metni" sections={content} page="nodate" />;
};
export default AcikRiza;
